// @module SA.ShopperApproved.ShopperApprovedModulePDPWidget
define('SA.ShopperApproved.ShopperApprovedModulePDPWidget.View',	[
	'sa_shopperapproved_shopperapprovedmodule_pdp_widget.tpl',	'Backbone'
], function (
	sa_shopperapproved_shopperapprovedmodule_pdp_widget_tpl, Backbone
) {
    'use strict';

	// @class SA.ShopperApproved.ShopperApprovedModulePDPWidget.View @extends Backbone.View
	return Backbone.View.extend({

		template: sa_shopperapproved_shopperapprovedmodule_pdp_widget_tpl

	,	initialize: function(options) {
			// console.log("options", options);

			this.item = options.iteminfo.item
			var self = this;
			
			self.on('afterViewRender', function afterViewRender(view) {
				self.loadReview();
			});

		},

		loadReview: function() {

			var sa_interval = 5000;
			var sa_product = this.item.itemid;
			    //sa_product = sa_product.replace(/[^\w\s]/gi, '');
				sa_product = sa_product.replace(/\s+/g, '_');
                sa_product = sa_product.split('_');
                sa_product = sa_product[sa_product.length-1];

            function saLoadScript(src) { var js = window.document.createElement('script'); js.src = src; js.type = 'text/javascript'; document.getElementsByTagName("head")[0].appendChild(js); } if (typeof(shopper_first) == 'undefined') saLoadScript('//www.shopperapproved.com/widgets/27282/product/'+sa_product+'/product-widget/9092x37JkVDL.js');
		},
		getContext: function() {
			// console.log('script', this.item.internalid)
			let itemSKU = this.item.itemid;
                //itemSKU = itemSKU.replace(/[^\w\s]/gi, '');
                itemSKU = itemSKU.replace(/\s+/g, '_'); // add underscore to the brand name
                itemSKU = itemSKU.split('_'); // split the brand name to the actual sku
                itemSKU = itemSKU[itemSKU.length-1]; // get the last array index 
			return {
				// @property {String} label
				prodid: itemSKU
			};
		}
	});
});
